import React, { useState, useEffect } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { Nav, NavItem, Dropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';

import api from '../../api/api.js';
import apifunctions from '../../api/functions.js';

const locationIsInPathRoute = (location, path) => (
	location && location.pathname && location.pathname.toLowerCase().indexOf(path) >= 0
);


const TiendaNavItem = (props) => {
	const {className} = props;
	const [Menues, setMenues] = useState([]);
	let active = locationIsInPathRoute(props.location, "/tienda/") && !locationIsInPathRoute(props.location, "/cliente/");

	useEffect(() => {
		const failureCallback = () => setMenues([]);
		const successCallback = ({ meta, data }) => {
			let Menues = [];
			try {
				Menues = data ? data : [];
			} catch (e) {
				Menues = [];
			}
			setMenues(Menues);
		};
		apifunctions.get(api.api.sitio.menu, null, null, { filters: ["paginationEnabled=False"] }, successCallback, failureCallback, failureCallback);
	}, []);

	const [dropdownOpen, setDropdownOpen] = useState(false);

	const toggle = () => setDropdownOpen(!dropdownOpen);

	return Menues && (
		Menues.length === 0 ? (
			<NavLink to="/tienda/productos" className={"nav-link" + (active ? " active" : "" ) + " " +(className ? className : "")}>TIENDA</NavLink>
		) : (
			<>
				<Dropdown nav center
					isOpen={dropdownOpen}
					toggle={() => { }}
					onMouseEnter={() => setDropdownOpen(true)}
					onMouseLeave={() => setDropdownOpen(false)}
					onClick={toggle}
				>
					<DropdownToggle nav caret>TIENDA</DropdownToggle>
					<DropdownMenu className="dropdown-menu-center">
						<DropdownItem><Link to="/tienda/productos">CATALOGO</Link></DropdownItem>
						<DropdownItem divider />
						{
							Menues.map((root, indexRoot) => (
								<React.Fragment key={"rootMenu-" + indexRoot}>
									<DropdownItem><Link to={`/tienda${root.href}`}>{root.Nombre}</Link></DropdownItem>
								</React.Fragment>
							))
						}
					</DropdownMenu>
				</Dropdown>
			</>
		)

	);
}

export default withRouter(TiendaNavItem);
